export const GET_PERSONA_AFFERENZA = 'GET_PERSONA_AFFERENZA';

/**
 * Get persona telefoni.
 * @function getPersonaAfferenza
 * @param {Object} data Data.
 * @returns {Object} Get querystringsearch results action.
 */
export function getPersonaAfferenza(path, data, subrequest, page) {
  return {
    type: GET_PERSONA_AFFERENZA,
    path,
    request: {
      op: 'get',
      path: `${path}/@getCatenaAfferenza`,
    },
  };
}
